import Vue from "vue";
import Vuex from "vuex";
import analytics from "./modules/analytics";
import tenant from "./modules/tenant";
import surveyResults from "./modules/surveyResults";
import analyticsPlugin from "./analyticsPlugin";

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		analytics,
		surveyResults,
		tenant
	},
	plugins: [analyticsPlugin]
});
